const PaymentChannelIDEnum = require('@/lib/Channels/PaymentChannelIDEnum');

/**
 * @typedef {(typeof PaymentChannelNameEnum)[keyof typeof PaymentChannelNameEnum]} PaymentChannelNameEnumValue
 */

const PaymentChannelNameEnum = Object.freeze({
    [PaymentChannelIDEnum.FRONTEND]: 'Online',
    [PaymentChannelIDEnum.BACKEND]: 'Back Office',
    [PaymentChannelIDEnum.EPOS]: 'ProPoint',
    [PaymentChannelIDEnum.TRADE_PORTAL]: 'Trade Portal',
    [PaymentChannelIDEnum.EXPERIENCE_BANK]: 'ExperienceBank',
    [PaymentChannelIDEnum.AUTOMATIC_RENEWALS]: 'Automatic Renewals',
    [PaymentChannelIDEnum.PRO_KIOSK]: 'ProKiosk',
    [PaymentChannelIDEnum.API]: 'API',
    [PaymentChannelIDEnum.PRO_MENU]: 'ProMenu',
});

module.exports = PaymentChannelNameEnum;
